import script from "./comment-card.vue?vue&type=script&setup=true&lang=js"
export * from "./comment-card.vue?vue&type=script&setup=true&lang=js"

import "./comment-card.vue?vue&type=style&index=0&id=458b0f9a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-458b0f9a"]])

export default __exports__